import { IProduct } from '../typings/IProduct';

export const getIndexProductOption = (product: Partial<IProduct>, idSellPoint: number | null) => {
  return 0;
};
